import { Component, computed, input, output } from '@angular/core';
import { CardComponent, SegmentHeaderComponent } from '@app/components';
import { TaxForm } from '@app/models/payroll/tax-form.abstract.model';
import { AppDatePipe } from '@app/pipes';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-employee-tax-form-details',
    standalone: true,
    imports: [CardComponent, SegmentHeaderComponent, TranslateModule, AppDatePipe],
    templateUrl: './employee-tax-form-details.component.html',
    styleUrl: './employee-tax-form-details.component.scss',
})
export class EmployeeTaxFormDetailsComponent {
    taxForm = input.required<TaxForm>();
    onEditEmployee = output<void>();

    address = computed(
        () =>
            `${this.taxForm().address1 || ''}${this.taxForm().address2 || ''}${this.taxForm().address3 || ''}, ${this.taxForm().locality || ''}, ${this.taxForm().adminArea || ''} ${this.taxForm().postCode || ''}`
    );
}
